import { render, staticRenderFns } from "./linkDialog.vue?vue&type=template&id=455b9d8b&scoped=true&"
import script from "./linkDialog.vue?vue&type=script&lang=js&"
export * from "./linkDialog.vue?vue&type=script&lang=js&"
import style0 from "./linkDialog.vue?vue&type=style&index=0&id=455b9d8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455b9d8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('455b9d8b')) {
      api.createRecord('455b9d8b', component.options)
    } else {
      api.reload('455b9d8b', component.options)
    }
    module.hot.accept("./linkDialog.vue?vue&type=template&id=455b9d8b&scoped=true&", function () {
      api.rerender('455b9d8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/invite/components/linkDialog.vue"
export default component.exports